import { Box, Typography } from '@mui/material';
import CustomAlert from 'components/shared/CustomAlert/CustomAlert';
import CustomAlertContain from 'components/shared/CustomAlert/CustomAlertContain';
import { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link, useParams } from 'react-router-dom';
import { BusinessesService } from 'service/businesses.service';
import zeplinColor from 'theme/Color';
import Card from './Card';

const News = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});
  const [news, setNews] = useState<any>([]);
  const pageRef = useRef(1);
  const [error, setError] = useState(false);

  const getCompanyNews = async (id: string) => {
    try {
      setLoading(true);
      const res = await BusinessesService.getBusinessNews(id, pageRef.current);
      setData(res.news);
      setNews((prev: any) => (pageRef.current === 1 ? res.news : [...prev, ...res.news]));
      pageRef.current++;
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setError(false);
  };

  useEffect(() => {
    if (id) {
      setNews([]);
      getCompanyNews(id);
    }
  }, [id]);

  return (
    <Box sx={{ display: 'flex', gap: { xs: '20px', xl: '32px' }, height: 'calc(100vh - 300px)' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 1,
          }}
        >
          <Typography variant='responsiveHeading3'>News</Typography>

          {!loading && news.length === 0 ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                flex: 1,
                height: '100%',
                gap: '32px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '24px',
                  width: '100%',
                }}
              >
                <img src={'/assets/no-zoominfo.svg'} alt='no zoominfo results' />
                <Typography
                  variant='responsiveHeading3'
                  color={zeplinColor.BasicBlack}
                  sx={{ marginTop: '0px' }}
                >
                  No news yet
                </Typography>
              </Box>
            </Box>
          ) : (
            <InfiniteScroll
              dataLength={news.length}
              loader={<>Loading</>}
              hasMore={news.length < data.maxResults}
              next={() => {
                if (!loading) {
                  getCompanyNews(id ?? '');
                }
              }}
              height={'calc(100vh - 230px)'}
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                width: '100%',
              }}
            >
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: 'repeat(3, minmax(250px, 1fr))',
                    sm: 'repeat(auto-fill, minmax(270px, 1fr))',
                    md: 'repeat(auto-fill, minmax(280px, 1fr))',
                    lg: 'repeat(auto-fill, minmax(290px, 1fr))',
                    xl: 'repeat(3, minmax(300px, 1fr))',
                  },
                  gap: '24px',
                  gridAutoRows: '1fr',
                  gridAutoFlow: 'row',
                  flex: 1,
                }}
              >
                {news.map((val: any) => (
                  <Link
                    to={val?.url}
                    rel='noopener noreferrer'
                    target='_blank'
                    style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
                    key={val.title}
                  >
                    <Card val={val} />
                  </Link>
                ))}
              </Box>
            </InfiniteScroll>
          )}
        </Box>
      </Box>
      <CustomAlert
        open={error ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alert={error ? 'Something went wrong.' : ''}
            alertIcon={<img src='/assets/error.svg' width={24} height={24} alt='error' />}
            error={error}
          />
        }
        error={error}
      />
    </Box>
  );
};

export default News;
